import Api from 'api';

import {
  GET_DEPRECIATION_REPORT,
  GET_DEPRECIATION_REPORT_PAGINATED,
  SET_DEPRECIATION_REPORT_PAGINATION,
  SET_DEPRECIATION_REPORT_FILTERS,
  RESET_DEPRECIATION_REPORT,
  GET_DEPRECIATION_REPORT_XLSX,
} from 'containers/reports/constants';

export const setPagination = (payload) => ({
  type: SET_DEPRECIATION_REPORT_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_DEPRECIATION_REPORT_FILTERS,
  payload,
});

export const getReport = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_DEPRECIATION_REPORT_PAGINATED,
  meta: { needAuth: true },
  payload: Api.reports.getDepreciationReportPaginated(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

export const getDepreciationCSV = (companyId, subcompanyId, filters) => ({
  type: GET_DEPRECIATION_REPORT,
  meta: { needAuth: true },
  payload: Api.reports.getDepreciationReport(companyId, subcompanyId, filters),
});

/**
 * @author Jorge Casas
 * @creationDate 27/04/2024
 * 
 * @description Get the depreciation assets report in XLSX format for a company and subcompany
 * 
 * @param {string} companyId - Company ID
 * @param {string} subcompanyId - Subcompany ID
 * @param {object} filters - Filters to apply to the report
 * @returns {Promise} - Promise object represents the XLSX file with the depreciation report 
 */
export const getDepreciationXLSX = (companyId, subcompanyId, filters) => ({
  type: GET_DEPRECIATION_REPORT_XLSX,
  meta: { needAuth: true },
  payload: Api.reports.getDepreciationReportXLSX(companyId, subcompanyId, filters),
});

export const resetReport = () => ({
  type: RESET_DEPRECIATION_REPORT,
});

export const getDepreciationPDF = (companyId, subcompanyId, filters) => ({
  type: GET_DEPRECIATION_REPORT,
  meta: { needAuth: true },
  payload: Api.reports.getDepreciationReportArray(companyId, subcompanyId, filters),
});



// WEBPACK FOOTER //
// src/containers/reports/actions_depreciation.js